import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { IconGeneric } from '@spotahome/ui-library';
import { trans } from '@spotahome/bff/client';

import FilterGroup from '../filter-group';
import CheckBox from '../../../ui/form/form-checkbox';

import './AreaFilters.scss';

const INITIAL_HEIGHT = '0px';
const MAX_OF_AREAS_TO_SHOW = 8;

const ShowMoreButton = ({ className, onClick, isDropDownActive }) => {
  const showMoreIconName = isDropDownActive ? 'angle-top' : 'angle-down';
  const showMoreLabelTrans = isDropDownActive
    ? 'search.filter.area.show_less'
    : 'search.filter.area.show_more';

  return (
    <div className={className}>
      <button className="show-more-button" onClick={onClick}>
        {trans(showMoreLabelTrans)}
        <IconGeneric name={showMoreIconName} color="green" />
      </button>
    </div>
  );
};

class AreaFilters extends Component {
  static propTypes = {
    cityAreas: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      }).isRequired
    ).isRequired,
    isAreaIdFilterChecked: PropTypes.func.isRequired,
    handleAreaFilterTypeCheckbox: PropTypes.func.isRequired
  };

  state = {
    isDropDownActive: false
  };

  calculateMaxHeight = () => {
    const contentStyles = this.filterWrapperBodyref.current;

    if (typeof window !== 'undefined') {
      return window.getComputedStyle(contentStyles).height;
    }
  };

  filterWrapperBodyref = React.createRef();

  handleOnChecked = areaId => {
    return this.props.isAreaIdFilterChecked(areaId);
  };
  handleOnChange = areaId => {
    return this.props.handleAreaFilterTypeCheckbox(areaId);
  };

  handleShowMore = () => {
    this.setState(prevState => ({
      isDropDownActive: !prevState.isDropDownActive
    }));
  };

  hasMoreAreasToShow = () => this.props.cityAreas.length > MAX_OF_AREAS_TO_SHOW;

  render() {
    const { cityAreas } = this.props;
    const { isDropDownActive } = this.state;

    const height = isDropDownActive
      ? this.calculateMaxHeight()
      : INITIAL_HEIGHT;

    return (
      <FilterGroup
        classModifier="checkboxes"
        label={trans('search.filter.area')}
      >
        <div className="wrapper-area-filters">
          <div>
            {cityAreas.slice(0, MAX_OF_AREAS_TO_SHOW).map(area => (
              <CheckBox
                id={`${area.id}`}
                key={area.id}
                label={trans(`${area.name}`)}
                tracking={`ga-search-form-area-${area.id}`}
                checked={this.handleOnChecked(`${area.id}`)}
                onChange={this.handleOnChange(`${area.id}`)}
              />
            ))}
          </div>
          {this.hasMoreAreasToShow() && (
            <Fragment>
              <div className="area-filters" style={{ height }}>
                <div ref={this.filterWrapperBodyref} className="clearfix">
                  {cityAreas.slice(8).map(area => (
                    <CheckBox
                      id={`${area.id}`}
                      key={area.id}
                      label={trans(`${area.name}`)}
                      tracking={`ga-search-form-area-${area.id}`}
                      checked={this.handleOnChecked(`${area.id}`)}
                      onChange={this.handleOnChange(`${area.id}`)}
                    />
                  ))}
                </div>
              </div>
              <ShowMoreButton
                className="wrapper-show-more-button"
                onClick={this.handleShowMore}
                isDropDownActive={isDropDownActive}
              />
            </Fragment>
          )}
        </div>
      </FilterGroup>
    );
  }
}

export default AreaFilters;
